import { SearchMenu } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SearchMenu/SearchMenu";

export { SearchMenu };
